<template>
  <emoji-picker @emoji="insert" :search="search">
    <div
      slot="emoji-invoker"
      slot-scope="{ events: { click: clickEvent } }"
      @click.stop="clickEvent"
    >
      <el-button slot="append" type="text" icon="fa fa-smile-o" />
    </div>
    <div slot="emoji-picker" slot-scope="{ emojis, insert }">
      <div class="emoji-picker">
        <div class="emoji-picker__search">
          <input type="text" v-model="search" />
        </div>
        <div class="emojis">
          <div v-for="(emojiGroup, category) in emojis" :key="category">
            <h5>{{ category }}</h5>
            <div>
              <span
                v-for="(emoji, emojiName) in emojiGroup"
                :key="emojiName"
                @click="insert(emoji)"
                :title="emojiName"
                >{{ emoji }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </emoji-picker>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker';

export default {
  name: 'EmojiKeyboard',
  components: {
    EmojiPicker,
  },
  data: () => ({
    search: '',
  }),
  methods: {
    insert(emoji) {
      this.$emit('onEmojiInsert', emoji);
    },
  },
};
</script>

<style scoped lang="scss">
.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  top: -20rem;
  left: -29rem;
  z-index: 1;
  border: 1px solid #ccc;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
  width: 100%;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  div {
    width: 100%;
  }
}
.emoji-picker .emojis:after {
  content: '';
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// EmojiKeyboard.vue?538f20d8